/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import SGColumnHeader from '@usas/ui-web/components/grids/SGColumnHeader';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import useSortableGrid from '@usas/ui-web/utils/UseSortableGrid';
import SGConstants from '@usas/ui-web/utils/SGConstants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ approvedMeetRequest, onApprovedRequestClicked }) => (
  <tr>
    <td><a onClick={e => onApprovedRequestClicked(e, approvedMeetRequest)}>{`${approvedMeetRequest.lscCode || ''} - ${approvedMeetRequest.clubName || ''}/${approvedMeetRequest.clubCode || ''}`}</a></td>
    <td>{formatDate(approvedMeetRequest.submissionDate)}</td>
    <td>{approvedMeetRequest.meetName}</td>
    <td>{`${formatDate(approvedMeetRequest.meetStartDate)} - ${formatDate(approvedMeetRequest.meetEndDate)}`}</td>
  </tr>
);

const LargeGrid = ({ data, isLoading, onApprovedRequestClicked }) => {
  const {
    sortableGridState,
    onColumnClicked
  } = useSortableGrid(data);

  return (
    <table className={[global.UsasTable, 'visible-lg visible-md'].join(' ')}>
      <thead>
        <tr>
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'LSC - Club Name/Club Code'} columnField={'lscCode'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Submission Date'} columnField={'submissionDate'}
            sortType={SGConstants.SORT_TYPE_DATE} onColumnClicked={onColumnClicked} />
          <SGColumnHeader sortableGridState={sortableGridState} columnLabel={'Meet Name'} columnField={'meetName'}
            sortType={SGConstants.SORT_TYPE_ALPHABETICAL} onColumnClicked={onColumnClicked} />
          <th>Meet Dates</th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true
          ? <tr><td colSpan="4">Loading...</td></tr>
          : sortableGridState.sortedGridData.length > 0
            ? sortableGridState.sortedGridData.map((approvedMeetRequest, i) => <GridRow key={i} approvedMeetRequest={approvedMeetRequest} onApprovedRequestClicked={onApprovedRequestClicked} />)
            : <tr><td colSpan="4">No Approved Meet Requests</td></tr>
        }
      </tbody>
    </table>
  );
};

export default LargeGrid;